import {
  AfterViewInit,
  Component,
  Inject,
  OnDestroy,
  Output,
  ViewChild,
  EventEmitter
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CadastroRegraComponent } from "../../cadastro-regra/cadastro-regra.component";
import { RegraService } from "../../regra.service";
import { Subscription } from "rxjs";
import { ToastService } from "maps-angular-components";


@Component({
  selector: "modal-editar-regra",
  templateUrl: "modal-editar-regra.component.html",
})
export class ModalEditarRegraDialogComponent
  implements AfterViewInit, OnDestroy {
  private readonly subscriptions = new Subscription();

  @ViewChild("cadastroComponent", { static: false })
  private readonly component: CadastroRegraComponent;

  private readonly service: RegraService;

  private readonly messageService: ToastService;

  private readonly params: any;

  onComplete = new EventEmitter();

  @Output() editado = new EventEmitter();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    service: RegraService,
    messageService: ToastService,
    public dialogRef: MatDialogRef<ModalEditarRegraDialogComponent>,
  ) {
    this.params = data;
    this.service = service;
    this.messageService = messageService;
  }

  ngAfterViewInit(): void {

  }

  closeDialog() {
    this.dialogRef.close();
    this.editado.emit();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
